module.exports = __webpack_public_path__ + "img/css_sprites-left-revised.913c58b.png";